import { Icon } from '@sgme/ui';
import { PromoteCard, PromoteCardProps } from 'components/promote-card/promote-card';
import { useToggleFeature } from 'hooks/useToggleFeature';
import { useIntl } from 'react-intl';
import { Link } from 'react-router-dom';
import { useLocalStorage } from 'usehooks-ts';

type EssentialPromoteCardProps = Pick<PromoteCardProps, 'variant' | 'className'>;

export function EssentialPromoteCard({ variant = 'default', className }: EssentialPromoteCardProps) {
  const [shown, setShown] = useLocalStorage('sp-essential-promote', true);
  const { formatMessage } = useIntl();
  const hasEssentialFeature = useToggleFeature('essentialWorkspaceParis');

  const isDefaultVariant = variant === 'default';

  const icon = isDefaultVariant ? <Icon icon="auto_mode" /> : undefined;
  const title = formatMessage({
    id: isDefaultVariant ? 'promote.essential.title' : 'promote.essential.discover.title',
  });
  const subTitle = !isDefaultVariant ? formatMessage({ id: 'promote.essential.discover.subtitle' }) : undefined;
  const linkText = formatMessage({ id: 'promote.essential.action' });

  const closePromotion = () => setShown(false);

  if (!shown || !hasEssentialFeature) {
    return null;
  }

  return (
    <PromoteCard
      variant={variant}
      icon={icon}
      title={title}
      subTitle={subTitle}
      className={className}
      onClose={closePromotion}
      action={
        <>
          <Link className="text-info" to="/essential">
            {linkText}
          </Link>
          <Icon size="sm" icon="arrow_forward" />
        </>
      }
    />
  );
}
